var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"inline-lg"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"form-check"},[_c('label',[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.value === option,"value":option},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v("\n        "+_vm._s(option)+"\n      ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared/components/RadioGroup.vue?vue&type=template&id=60c6039a&
// module id = null
// module chunks = 